(() => {
  var e = {
      415: (e, r, t) => {
        "use strict";

        var n = t(414);
        function o() {}
        function a() {}
        a.resetWarningCache = o, e.exports = function () {
          function e(e, r, t, o, a, i) {
            if (i !== n) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }
          function r() {
            return e;
          }
          e.isRequired = e;
          var t = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: r,
            element: e,
            elementType: e,
            instanceOf: r,
            node: e,
            objectOf: r,
            oneOf: r,
            oneOfType: r,
            shape: r,
            exact: r,
            checkPropTypes: a,
            resetWarningCache: o
          };
          return t.PropTypes = t, t;
        };
      },
      5: (e, r, t) => {
        e.exports = t(415)();
      },
      414: e => {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }
    },
    r = {};
  function t(n) {
    var o = r[n];
    if (void 0 !== o) return o.exports;
    var a = r[n] = {
      exports: {}
    };
    return e[n](a, a.exports, t), a.exports;
  }
  t.n = e => {
    var r = e && e.__esModule ? () => e.default : () => e;
    return t.d(r, {
      a: r
    }), r;
  }, t.d = (e, r) => {
    for (var n in r) t.o(r, n) && !t.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: r[n]
    });
  }, t.o = (e, r) => Object.prototype.hasOwnProperty.call(e, r), t.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (() => {
    "use strict";

    t.r(n), t.d(n, {
      default: () => l
    });
    const e = require("react");
    var r = t.n(e),
      o = t(5),
      a = t.n(o);
    function i(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, n);
      }
      return t;
    }
    function s(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? i(Object(t), !0).forEach(function (r) {
          c(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : i(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function c(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    var p = function (e) {
      var t = e.color,
        n = e.background,
        o = e.loading,
        a = e.promiseTracker,
        i = {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: e.zIndex,
          background: "rgba(255,255,255,.5)",
          backfaceVisibility: "hidden"
        },
        c = (!!a && a()).promiseInProgress,
        p = s(s({}, i), {}, {
          background: n
        });
      return o || c ? r().createElement("div", {
        style: p
      }, r().createElement("div", {
        style: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: 100,
          height: 100
        }
      }, r().createElement("svg", {
        className: "lds-spinner",
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid"
      }, [{
        transform: "rotate(0 50 50)",
        begin: "-0.9166666666666666s"
      }, {
        transform: "rotate(30 50 50)",
        begin: "-0.8333333333333334s"
      }, {
        transform: "rotate(60 50 50)",
        begin: "-0.75s"
      }, {
        transform: "rotate(90 50 50)",
        begin: "-0.6666666666666666s"
      }, {
        transform: "rotate(120 50 50)",
        begin: "-0.5833333333333334s"
      }, {
        transform: "rotate(150 50 50)",
        begin: "-0.5s"
      }, {
        transform: "rotate(180 50 50)",
        begin: "-0.4166666666666667s"
      }, {
        transform: "rotate(210 50 50)",
        begin: "-0.3333333333333333s"
      }, {
        transform: "rotate(240 50 50)",
        begin: "-0.25s"
      }, {
        transform: "rotate(270 50 50)",
        begin: "-0.16666666666666666s"
      }, {
        transform: "rotate(300 50 50)",
        begin: "-0.08333333333333333s"
      }, {
        transform: "rotate(330 50 50)",
        begin: "0s"
      }].map(function (e) {
        return r().createElement("g", {
          key: e.transform,
          transform: e.transform
        }, r().createElement("rect", {
          x: "47",
          y: "24",
          rx: "9.4",
          ry: "4.8",
          width: "6",
          height: "12",
          fill: t
        }, r().createElement("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: e.begin,
          repeatCount: "indefinite"
        })));
      })))) : "";
    };
    p.propTypes = {
      color: a().string,
      loading: a().bool,
      background: a().string,
      promiseTracker: a().any,
      zIndex: a().number
    }, p.defaultProps = {
      color: "#000",
      loading: !1,
      background: "rgba(255,255,255,.5)",
      promiseTracker: !1,
      zIndex: 999
    };
    const l = p;
  })(), module.exports = n;
})();